/* LOUNELLE_OBSERVED_PRICE_V7 */
(function () {
  'use strict';

  var STYLE_ID = 'ln-observed-price-style';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;

    style.textContent = [
      /*
       * Layout only.
       * Shopify remains responsible for the actual formatted money string.
       */
      'product-info .ln-observed-price{' +
        'display:flex!important;' +
        'align-items:center!important;' +
        'flex-wrap:nowrap!important;' +
        'gap:8px 12px!important;' +
        'max-width:100%!important;' +
      '}',

      /*
       * Sale price.
       * No currency parsing/rebuilding: Shopify output is kept untouched.
       */
      'product-info .ln-observed-price [data-product-price]{' +
        'display:inline-flex!important;' +
        'align-items:center!important;' +
        'justify-content:center!important;' +
        'text-align:center!important;' +
        'flex:0 0 auto!important;' +
        'box-sizing:border-box!important;' +
        'min-width:82px!important;' +
        'min-height:44px!important;' +
        'padding:7px 9px!important;' +
        'margin:0!important;' +
        'border:0!important;' +
        'border-radius:6px!important;' +
        'background:var(--lounelle-announcement-accent,#ebc8cf)!important;' +
        'color:var(--lounelle-announcement-text,#0b0b0b)!important;' +
        'text-decoration:none!important;' +
        'white-space:nowrap!important;' +
      '}',

      /*
       * Native compare-at price.
       * The <s> generated by the theme is kept and explicitly struck through.
       */
      'product-info .ln-observed-price [data-compare-price]{' +
        'display:inline-flex!important;' +
        'align-items:center!important;' +
        'justify-content:center!important;' +
        'flex:0 1 auto!important;' +
        'min-width:0!important;' +
        'margin:0!important;' +
        'white-space:nowrap!important;' +
        'text-decoration-line:line-through!important;' +
        'text-decoration-thickness:1.5px!important;' +
        'text-decoration-color:currentColor!important;' +
        'text-decoration-skip-ink:none!important;' +
      '}',

      /*
       * Hide Palo Alto's native saving badge because Lounelle uses
       * its own dated discount badge beside the price.
       */
      'product-info .ln-observed-price .product__price-badge{' +
        'display:none!important;' +
      '}',

      '.ln-observed-price__actions{' +
        'display:inline-flex!important;' +
        'align-items:center!important;' +
        'flex:0 0 auto!important;' +
        'white-space:nowrap!important;' +
      '}',

      '.ln-observed-price__discount{' +
        'display:inline-flex;' +
        'align-items:center;' +
        'justify-content:center;' +
        'min-height:32px;' +
        'box-sizing:border-box;' +
        'padding:6px 8px;' +
        'border-radius:4px;' +
        'background:var(--lounelle-announcement-accent,#ebc8cf);' +
        'color:var(--lounelle-announcement-text,#0b0b0b);' +
        'font-size:13px;' +
        'font-weight:500;' +
        'line-height:1;' +
        'white-space:nowrap;' +
      '}',

      '@media (max-width:749px){' +
        'product-info .ln-observed-price{' +
          'flex-wrap:nowrap!important;' +
          'gap:clamp(2px,1.1vw,5px)!important;' +
        '}' +

        'product-info .ln-observed-price [data-product-price]{' +
          'min-width:0!important;' +
          'min-height:40px!important;' +
          'padding:6px clamp(5px,1.8vw,7px)!important;' +
        '}' +

        'product-info .ln-observed-price [data-compare-price]{' +
          'flex:0 0 auto!important;' +
          'font-size:clamp(11px,3.2vw,13px)!important;' +
        '}' +

        '.ln-observed-price__actions{' +
          'flex:0 1 auto!important;' +
          'min-width:0!important;' +
          'white-space:nowrap!important;' +
        '}' +

        '.ln-observed-price__discount{' +
          'min-width:0;' +
          'min-height:28px;' +
          'padding:5px clamp(3px,1.2vw,6px);' +
          'font-size:clamp(8.5px,2.7vw,10.5px);' +
          'line-height:1;' +
          'letter-spacing:-0.01em;' +
          'white-space:nowrap;' +
        '}' +
      '}'
    ].join('');

    document.head.appendChild(style);
  }

  /*
   * Used only to calculate the percentage discount.
   * The displayed money string itself is never altered.
   */
  function parseMoney(text) {
    var cleaned = String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, '')
      .replace(/[^0-9,.-]/g, '');

    if (!cleaned) return NaN;

    var comma = cleaned.lastIndexOf(',');
    var dot = cleaned.lastIndexOf('.');
    var separator = Math.max(comma, dot);

    if (separator > -1 && cleaned.length - separator - 1 === 2) {
      var integerPart = cleaned.slice(0, separator).replace(/[.,]/g, '');
      var decimals = cleaned.slice(separator + 1).replace(/[^0-9]/g, '');

      return parseFloat(integerPart + '.' + decimals);
    }

    return parseFloat(cleaned.replace(/[.,]/g, ''));
  }

  function storefrontLocale() {
    var language = String(document.documentElement.lang || 'fr').trim();
    var country = String(
      (window.Shopify && window.Shopify.country) || ''
    ).trim().toUpperCase();

    var locale =
      country && language.indexOf('-') === -1
        ? language + '-' + country
        : language;

    try {
      return (
        Intl.DateTimeFormat.supportedLocalesOf([locale, language])[0] ||
        language ||
        'fr'
      );
    } catch (_) {
      return language || 'fr';
    }
  }

  function getI18nConfig() {
    var node = document.getElementById('LounellePdpI18n');

    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function getDiscountDateLabel(sale, compare) {
    var discount = Math.round((1 - sale / compare) * 100);

    if (!Number.isFinite(discount) || discount <= 0) {
      return '';
    }

    var config = getI18nConfig();
    var template = String(
      (config && config.observedPriceTemplate) || ''
    );

    if (!template) return '';

    var today = new Date();
    var locale = storefrontLocale();
    var dateLabel;

    try {
      dateLabel = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long'
      }).format(today);
    } catch (_) {
      dateLabel = today.toLocaleDateString();
    }

    return template
      .replace(/\[DISCOUNT\]/g, String(discount))
      .replace(/\[DATE\]/g, dateLabel);
  }

  function cleanupLegacyUi() {
    document
      .querySelectorAll('.ln-observed-price__info')
      .forEach(function (node) {
        node.remove();
      });

    var legacyModal = document.getElementById(
      'ln-observed-price-modal'
    );

    if (legacyModal) {
      legacyModal.remove();
    }

    if (document.body) {
      document.body.classList.remove(
        'ln-observed-price-modal-open'
      );
    }
  }

  /*
   * Compatibility cleanup for markup produced by old V6.
   * On a normal page load this should do nothing.
   */
  function restoreLegacyMarkup(element, markerSelector) {
    if (!element) return;

    var marker = element.querySelector(markerSelector);

    if (!marker) return;

    var original = element.dataset.lnObservedOriginal;

    if (typeof original === 'string' && original !== '') {
      element.textContent = original;
    }

    delete element.dataset.lnObservedOriginal;
    delete element.dataset.lnObservedValue;
    delete element.dataset.lnObservedCurrency;
  }

  function ensureActions(priceContainer, sale, compare) {
    cleanupLegacyUi();

    var actions = priceContainer.querySelector(
      '.ln-observed-price__actions'
    );

    if (!actions) {
      actions = document.createElement('span');
      actions.className = 'ln-observed-price__actions';

      var discount = document.createElement('span');
      discount.className = 'ln-observed-price__discount';

      actions.appendChild(discount);
      priceContainer.appendChild(actions);
    }

    var discountNode = actions.querySelector(
      '.ln-observed-price__discount'
    );

    if (!discountNode) return;

    var nextText = getDiscountDateLabel(sale, compare);

    if (discountNode.textContent !== nextText) {
      discountNode.textContent = nextText;
    }
  }

  function removeActions(priceContainer) {
    var actions = priceContainer.querySelector(
      '.ln-observed-price__actions'
    );

    if (actions) {
      actions.remove();
    }
  }

  function syncProductInfo(root) {
    var priceContainer =
      root.querySelector(
        '[id^="Price-"] [data-price-wrapper]'
      ) ||
      root.querySelector(
        '[data-price-wrapper]:not([data-atc-button])'
      );

    if (
      !priceContainer ||
      priceContainer.hasAttribute('data-atc-button')
    ) {
      return;
    }

    var priceEl = priceContainer.querySelector(
      '[data-product-price]'
    );

    var compareEl = priceContainer.querySelector(
      '[data-compare-price]'
    );

    if (!priceEl || !compareEl) {
      return;
    }

    /*
     * Remove only legacy V6 markup if somehow still present.
     * Afterwards Shopify's native text remains untouched.
     */
    restoreLegacyMarkup(
      priceEl,
      '.ln-observed-price__major'
    );

    restoreLegacyMarkup(
      compareEl,
      '.ln-observed-reference__value'
    );

    var sale = parseMoney(priceEl.textContent);
    var compare = parseMoney(compareEl.textContent);

    var compareIsHidden =
      compareEl.classList.contains('hidden') ||
      compareEl.style.display === 'none' ||
      compareEl.hasAttribute('hidden');

    var active =
      Number.isFinite(sale) &&
      Number.isFinite(compare) &&
      compare > sale &&
      !compareIsHidden;

    if (!active) {
      priceContainer.classList.remove(
        'ln-observed-price'
      );

      removeActions(priceContainer);

      return;
    }

    priceContainer.classList.add(
      'ln-observed-price'
    );

    ensureActions(
      priceContainer,
      sale,
      compare
    );
  }

  function initProductInfo(root) {
    if (
      !root ||
      root.dataset.lnObservedPriceInit === '1'
    ) {
      return;
    }

    root.dataset.lnObservedPriceInit = '1';

    var scheduled = false;

    function schedule() {
      if (scheduled) return;

      scheduled = true;

      window.requestAnimationFrame(function () {
        scheduled = false;
        syncProductInfo(root);
      });
    }

    var observer = new MutationObserver(schedule);

    observer.observe(root, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        'style',
        'hidden'
      ]
    });

    schedule();
  }

  function initAll() {
    document
      .querySelectorAll('product-info')
      .forEach(initProductInfo);
  }

  injectStyles();
  cleanupLegacyUi();

  document.addEventListener(
    'theme:product-info:loaded',
    function (event) {
      var root =
        event.target.closest
          ? event.target.closest('product-info')
          : null;

      if (root) {
        initProductInfo(root);
      } else {
        initAll();
      }
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      { once: true }
    );
  } else {
    initAll();
  }
})();